import { LinkReturnToMain } from 'Components';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

export const LinkReturnToLobby = () => {
  const { setStepIndex } = useContext(SuppliersContext);
  const navigate = useNavigate();

  return (
    <LinkReturnToMain
      label={Dictionary[DICTIONARY.General].back}
      onClick={() => {
        setStepIndex(SUPPLIERS_STEPS.FORM);
        navigate('/suppliers/therapy');
      }}
    />
  );
};
